<header class="page-header">
    <h2>Unauthorized</h2>

    <div class="right-wrapper pull-right">
        <ol class="breadcrumbs">
            <li>
                <a href="">
                    <i class="fa fa-home"></i>
                </a>
            </li>
            <li><span>Unauthorized</span></li>
        </ol>

    </div>
</header>

<!-- start: page -->
<section class="body-error error-inside">
    <div class="center-error">

        <div class="row">
            <div class="col-md-8">
                <div class="main-error mb-xlg">
                    <h2 class="error-code text-dark text-center text-weight-semibold m-none">401 <i class="fa fa-ban"></i></h2>
                    <p class="error-explanation text-center">We're sorry, but you either dont have access or the page you were looking for doesn't exist.</p>
                </div>
            </div>
            <div class="col-md-4">
            </div>
        </div>
    </div>
</section>
<!-- end: page -->
